import { useDispatch, useSelector } from "react-redux";
import MyNotification from "./MyNotification";
import { useEffect, useState } from "react";
import userProfileSelectors from "redux/UserProfile/selectors";
import { operations as navigationOperations } from "redux/Navigation";
import navOperations from '../../../../../redux/Navigation/operations'
import OrderDispatch from "Store/OrderManagement/Order/OrderDispatch";
import { AlertNotificationDispatch as myNotificationDispatch} from "Store/AlertNotification/AlertNotificationDispatch";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { SetDeleteAllNotifications, SetDeleteAlertNotificationdetails } from "Store/AlertNotification/AlertNotificationAction";
import TransferOrderDispatch from 'Store/Transfer/Transfer/TransferOrderByIdDispatch'
import { CONSTANTS } from "client/utils/constants";
import { useNavigate } from "react-router-dom";
import TransferAction from "Store/Component/Transfer/TransferAction";

const MyNotificationContainer = (props: any) => {
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteAllNotifications, setDeleteAllNotification] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dispatchGetMyAlertNotificationDetails = myNotificationDispatch.dispatchGetMyAlertNotificationDetails(dispatch);  
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);  
  const dispatchGetDeleteAllNotifications = myNotificationDispatch.dispatchSetDeleteAllNotifications(dispatch);  

  const { myNotificationDetails, userDetails, deleteAllNotificationsFlag, isAlertNotificationApiCalled }: any = useSelector(
    (state: any) => ({
        myNotificationDetails:state.AlertAndNotificationsReducer.myAlertNotificationDetails,
        isAlertNotificationApiCalled: state.AlertAndNotificationsReducer.isAlertNotificationApiCalled,
        userDetails: userProfileSelectors.getUserDetails(state),
        deleteAllNotificationsFlag: state.AlertAndNotificationsReducer.deleteAllNotifications
    })
  );
  const deleteNotificationflag: any = useSelector((state: any) => ({
    deleteNotificationflag:state.AlertAndNotificationsReducer.DeleteAlertNotificationDetails

  }));

  useEffect(() => {
    if (deleteAllNotificationsFlag || deleteNotificationflag.deleteNotificationflag) {
      dispatchGetMyAlertNotificationDetails(userDetails?.userId);
      dispatch(SetDeleteAlertNotificationdetails(false));
      dispatch(SetDeleteAllNotifications(false));
    }
  }, [deleteAllNotificationsFlag, deleteNotificationflag])

  const onDeleteConfirm = async () => {
    
    const dispatchGetDeleteAlertNotificationdetails = myNotificationDispatch.dispatchGetDeleteAlertNotificationdetails(dispatch);
    const deleteNotification={"notificationId":deletePopup,"userId":userDetails?.userId};
    dispatchGetDeleteAlertNotificationdetails(deleteNotification);
    if (deleteNotificationflag) {
      setDeletePopup(false);
    }
  };

  const onOrderClick = (orderId: any, navigateTo: any, item: any, isBulkOrder: boolean, fullTextContent?: string) => {
    dispatch(RequisitionAction.setIsChangesOccured(false))
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
    if (navigateTo && orderId) {
      if (item?.includes(CONSTANTS.TRANSFER) || item?.includes(CONSTANTS.DISPOSITION) || item?.includes(CONSTANTS.REACTIVATION)) {
        navigate('/ordermanagement/assetorderdetail/' + orderId + '/home');
      } else if(isBulkOrder){
        navigate('/ordermanagement/bulkorderdetail/' + orderId + '/home');  
      } else if(fullTextContent?.includes('AFE Request')){
        navigate('/ordermanagement/afeorderdetail/' + orderId + '/home' + '/' + CONSTANTS.AFEREQUEST);
      }else {
        navigate('/ordermanagement/requisitionorderdetail/' + orderId + '/home');
      }
    }
    if (navigateTo == "PendingApprovalOrders") {
      dispatchHeaderNav("Home")
    }
  };

  useEffect(() => {
    myNotificationDetails?.notificationDetails?.forEach(
      (value: any, index: any) => {
        const linkTag = document
          .querySelector(`.click-notification-${index}`)
          ?.querySelector("a");
        const orderId = linkTag?.getAttribute("data-orderid");
        const navigationPath = linkTag?.getAttribute("data-navigationpath");

        let divContainer = document.createElement("div");
        divContainer.innerHTML = value?.notificationMessage;
        let text = (divContainer?.childNodes[0]?.childNodes[2]?.textContent);
        let isBulkOrder = (divContainer?.childNodes[0]?.childNodes[0]?.childNodes[1]?.textContent) === CONSTANTS?.BULK_ORDER;
        let fullTextContent = value?.notificationMessage; // Get the full HTML content to check for AFE Request
        linkTag?.removeEventListener("click", () => { });
        linkTag?.addEventListener("click", (e : any) => {
          e.preventDefault();
          onOrderClick(orderId, navigationPath, text, isBulkOrder, fullTextContent);
        });
      }
    );
  }, [myNotificationDetails?.notificationDetails]);

  const clearAllOnClick = (e: any) => {
    e.preventDefault()
    if(myNotificationDetails?.notificationCount > 0){
      setDeleteAllNotification(true);
    }
  }

  const onDeleteAllNotificationConfirmation = () => {
    dispatchGetDeleteAllNotifications(userDetails?.emailId)
    setDeleteAllNotification(false)
  }

  return (
    <MyNotification
      myNotificationDetails={myNotificationDetails}
      onDeleteConfirm={onDeleteConfirm}
      deletePopup={deletePopup}
      setDeletePopup={setDeletePopup}
      clearAllOnClick = {clearAllOnClick}
      onDeleteAllNotificationConfirmation = {onDeleteAllNotificationConfirmation}
      deleteAllNotifications = {deleteAllNotifications}
      setDeleteAllNotification = {setDeleteAllNotification}
      isLoading={isAlertNotificationApiCalled}
      />
  );
};

export default MyNotificationContainer;
